/* eslint-disable indent */
import { Box, Button, Grid, Modal, Typography } from "@mui/material";
import Colors from "@constants/Colors";
import styled from "styled-components";
import { ZIndex } from "@src/constants";

export const StyledRootBox = styled(Box)<{
  isDesktop: boolean;
}>`
  display: flex !important;
  flex-direction: ${(props) => (props.isDesktop ? "" : "column")} !important;
  padding: 0 16px 16px !important;
  gap: 16px !important;
  border-radius: 12px !important;
  flex-wrap: ${(props) => (props.isDesktop ? "wrap" : "")};
`;

export const StyledBox = styled(Box)`
  display: flex;
  background: ${Colors.white} !important;
  position: sticky !important;
  z-index: ${ZIndex.LEVEL_4};
  gap: 8px !important;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  border: 1px solid ${Colors.neutral_gray_300};
  border-radius: 8px;
  padding: 6px 12px;
  width: 50% !important;
  .icon {
    border-radius: 0px;
    padding: 0px;
    background-color: transparent;
    cursor: pointer;
    &:hover {
      background-color: transparent;
    }
  }
`;

export const StyledTypography = styled(Typography)`
  &.css-ahj2mt-MuiTypography-root {
    font-family: "Ringside Regular-Book" !important;
    font-weight: 325 !important;
    font-size: 16px !important;
    line-height: 24px !important;
    display: flex !important;
    align-items: center !important;
    height: 32px !important;
    color: ${Colors.neutral_gray_500} !important;
  }
`;

export const StyledButton = styled(Button)<{ backgroundColor: string }>`
  font-family: Ringside Regular-Bold !important;
  font-weight: 400 !important;
  background-color: ${({ backgroundColor }: { backgroundColor: string }) =>
    backgroundColor} !important;
  font-size: 16px !important;
  line-height: 24px !important;
  display: flex !important;
  align-items: center !important;
  border-radius: 8px !important;
  padding: 3px 16px !important;
  height: 32px;
  font-style: normal;
  color: ${({ backgroundColor }: { backgroundColor: string }) =>
    backgroundColor === Colors.primary
      ? ""
      : Colors.neutral_gray_500} !important;
`;

export const StyledGrid = styled(Grid)<{
  isDesktop: boolean;
}>`
  display: flex;
  flex-direction: row;
  background: ${Colors.neutralwhite_50} !important;
  position: sticky !important;
  top: ${(props) => (props.isDesktop ? "80px" : "122px")};
  justify-content: space-between;
  padding: 16px;
  z-index: ${ZIndex.LEVEL_4};
  gap: 16px !important;
`;

export const StyledModel = styled(Modal)`
  display: flex !important;
  top: 44px !important;
  border-radius: 8px;
`;

export const EventSelectionBox = styled(Box)`
  overflow-y: scroll;
  overflow-x: hidden;
  background: ${Colors.white};
`;
